import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type InterviewConsentWithdrawalFailedAction = {
	type: 'INTERVIEW_CONSENT_WITHDRAWAL_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): InterviewConsentWithdrawalFailedAction => ({
	type: 'INTERVIEW_CONSENT_WITHDRAWAL_FAILED',
	payload,
});
